import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';
import { environment } from '../../../src/environments/environment';

@Injectable()
export class MixpanelService {
  constructor(protected http: HttpClient) {}

  public get people() {
    return mixpanel.people;
  }

  public get panel() {
    return mixpanel;
  }

  /**
   * Initialize mixpanel.
   *
   * @param {string} userToken
   * @memberof MixpanelService
   */
  init(userToken: string): void {
    mixpanel.init(environment.mixPanelSettings.token, {
      api_host: 'https://api.mixpanel.com'
    });
    mixpanel.identify(userToken);
  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelService
   */
  track(id: string, action: any = {}): void {
    this.http
      .post(
        environment.apiCadastroSettings.url +
          environment.apiCadastroSettings.track,
        { message: id, email: this.panel.persistence.props.distinct_id }
      )
      .subscribe();
  }
}
